import ReactHtmlParser from 'react-html-parser';
import { getLang, getProvince } from '../utils';

export default class NavHelper {
	getDealerId() {
		//summaryCalculator.getDealerVars() ? summaryCalculator.getDealerVars().dealerId : null;
		if (window.bnp_retailer_mode && sessionStorage.getItem('bnp_dealerVars')) {
			const dealerVars = JSON.parse(sessionStorage.getItem('bnp_dealerVars'));
			return dealerVars.dealerId;
		}

		return null;
	}
	getUrlSlug(returnDef) {
		let summaryCalculator = window.summaryCalculator;

		const year = returnDef ? '' : summaryCalculator.selectedVehicle.year;
		const carline = returnDef ? '' : summaryCalculator.selectedVehicle.carline;
		const trim = returnDef ? '' : summaryCalculator.selectedVehicle.trim ?? summaryCalculator.AvailableTrim.trims[0].trim_type.url_slug;
		const dealerId = this.getDealerId();
		let model = '';
		let packageCode = '';
		
		model = summaryCalculator.selectedVehicle.model === null ? '' : summaryCalculator.selectedVehicle.model;
		//model = model === '' ? summaryCalculator.AvailableTrim.trims[0].financial.based_on.model_code : '';

		packageCode = summaryCalculator.selectedVehicle.packageCode === null ? '' :  summaryCalculator.selectedVehicle.packageCode;
		//packageCode = packageCode === '' ? summaryCalculator.selectedVehicle.packageCode : '';

		//return `/${year}/${carline}?prov_code=${province}&lang_code=${lang}`; // trim
		return `/${year}/${carline}/${trim}?prov_code=${getProvince()}&lang_code=${getLang()}${dealerId ? `&DealerID=${dealerId}` : ''}`; // engine and drivetrain
		return `/${year}/${carline}/${trim}/${model}/${packageCode}?prov_code=${getProvince()}&lang_code=${getLang()}`; // package
	}
	getNavContent( t, returnDef){
		let summaryCalculator = window.summaryCalculator;

		const currentStep = returnDef ? '' : summaryCalculator.CurrentStep;
		const year = returnDef ? '' : summaryCalculator.selectedVehicle.year;
		const carline = returnDef ? '' : summaryCalculator.selectedVehicle.carline;
		const trim = returnDef ? '' : summaryCalculator.selectedVehicle.trim ?? summaryCalculator.AvailableTrim.trims[0].trim_type.url_slug;

		let model = '';
		let packageCode = '';
		
		model = summaryCalculator.selectedVehicle.model === null ? '' : summaryCalculator.selectedVehicle.model;
		//model = model === '' ? summaryCalculator.AvailableTrim.trims[0].financial.based_on.model_code : '';

		packageCode = summaryCalculator.selectedVehicle.packageCode === null ? '' :  summaryCalculator.selectedVehicle.packageCode;
		//packageCode = packageCode === '' ? summaryCalculator.selectedVehicle.packageCode : '';

		const province = getProvince();
		const lang = getLang();
		const dealerId = this.getDealerId();
		
		const navTranslation = [
			"general:nav_trim",
			"general:nav_options",
	        "general:nav_colour",
			"general:nav_wheels",
			"general:nav_connectivity",
			"general:nav_accessories",
			"general:nav_protection",
	        "general:nav_payments",
	        "general:nav_summary",
	        "general:nav_start_over",
	        "general:nav_start_over_mobile"
	    ];
		const tabs = {
			'tabList': [
				{
					"text": ReactHtmlParser(t(navTranslation[0])),
					"active": currentStep === 1,
					"uri": `/${year}/${carline}?prov_code=${province}&lang_code=${lang}${dealerId ? `&DealerID=${dealerId}` : ''}`
				},
				{
					"text": ReactHtmlParser(t(navTranslation[1])),
					"active": currentStep === 2,
					"uri": this.getUrlSlug(returnDef)
				},
				{
					"text": ReactHtmlParser(t(navTranslation[2])),
					"active": currentStep === 3,
					"uri": `/${year}/${carline}/${trim}/${model}/${packageCode}/colours?prov_code=${province}&lang_code=${lang}${dealerId ? `&DealerID=${dealerId}` : ''}`
				},
				{
					"text": ReactHtmlParser(t(navTranslation[3])),
					"active": currentStep === 4,
					"uri": `/${year}/${carline}/${trim}/${model}/${packageCode}/wheels?prov_code=${province}&lang_code=${lang}${dealerId ? `&DealerID=${dealerId}` : ''}`
				},
/*				{
					"text": ReactHtmlParser(t(navTranslation[4])),
					"active": currentStep === 5,
					"uri": `/${year}/${carline}/${trim}/${model}/${packageCode}/connectivity?prov_code=${province}&lang_code=${lang}`
				},*/
				{
					"text": ReactHtmlParser(t(navTranslation[5])),
					"active": currentStep === 6,
					"uri": `/${year}/${carline}/${trim}/${model}/${packageCode}/accessories?prov_code=${province}&lang_code=${lang}${dealerId ? `&DealerID=${dealerId}` : ''}`
				},
/*				{
					"text": ReactHtmlParser(t(navTranslation[6])),
					"active": currentStep === 7,
					"uri": `/${year}/${carline}/${trim}/${model}/${packageCode}/protections?prov_code=${province}&lang_code=${lang}`
				},*/
				{
					"text": ReactHtmlParser(t(navTranslation[7])),
					"active": currentStep === 8,
					"uri": `/${year}/${carline}/${trim}/${model}/${packageCode}/payments?prov_code=${province}&lang_code=${lang}${dealerId ? `&DealerID=${dealerId}` : ''}`
				},
				{
					"text": ReactHtmlParser(t(navTranslation[8])),
					"active": currentStep === 9,
					"uri": `/${year}/${carline}/${trim}/${model}/${packageCode}/summary?prov_code=${province}&lang_code=${lang}${dealerId ? `&DealerID=${dealerId}` : ''}`
				},
			],

			"selectVehiclesLinkLink": {
				"textDesktop": t(navTranslation[9]),
				"textMobile": t(navTranslation[9]),
				"uri": `/${dealerId ? `&DealerID=${dealerId}` : ''}`
			}

		}
		return tabs;
	}
}